@use '@design/design-tokens/typography/typography' as *;

.nodeWrapper {
  display: flex;
  padding-left: calc(var(--level) * 20px);

  [data-checkbox] {
    align-items: center;
  }

  [data-check-icon] {
    width: 18px;
    height: 18px;
  }

  [data-checkmark] {
    margin-top: 0;
    margin-right: 6px;
  }

  [data-checkbox-label] {
    @include typography-v2-body-sm;
  }
}
